import React from 'react';

import { useIntl } from 'react-intl';

import PlaylistGroup from 'components/PlaylistGroup';

import { SAC_TRACKING_NAME } from 'containers/SexualAnxietyClass';

import { useGetPlaylistsQuery } from 'graphql/generated/graphql';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';
import useStaticValues from 'hooks/useStaticValues';

const CourseRecommendations = () => {
  const { locale } = useIntl();
  const { sexualAnxietyClass } = useStaticValues({ locale });

  const { data: playlistsData, loading } = useGetPlaylistsQuery({
    ...useGraphaelDefaults(),
    variables: {
      filters: {
        ids: sexualAnxietyClass.recommendations,
      },
    },
  });

  const playlists = [...(playlistsData?.playlists || [])].sort((a, b) => {
    return a.id.localeCompare(b.id);
  });

  const shouldHide = !loading && playlists.length === 0;

  if (shouldHide) {
    return null;
  }

  return (
    <PlaylistGroup
      loading={loading}
      playlists={playlists!}
      title={{ id: 'components.sac.recommendations.title' }}
      subtitle={{ id: 'components.sac.recommendations.description' }}
      trackingCategory={`${SAC_TRACKING_NAME}-recommendations`}
    />
  );
};

export default CourseRecommendations;
